import { v4 as uuid } from 'uuid';
import { isShallowEqual } from '@atlassian/jira-platform-shallow-equal/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createContainer } from '@atlassian/react-sweet-state';
import { actions, onSearchInputUpdate } from './actions.tsx';
import type { State, Actions, Props } from './types.tsx';

const initialState: State = {
	disposables: [],
	isFetching: false,
	isFetchingView: false,
	isRefreshing: false,
	isNetworkError: false,
	searchKey: '',
	totalIssueCount: null,
	totalIssueCountIsFetching: false,
	totalIssueCountIsError: false,
};

export const IssueSearchServiceContainer = createContainer<Props>();

export const Store = createStore<State, Actions, Props>({
	name: 'IssueSearchServiceStore',
	initialState,
	actions,
	containedBy: IssueSearchServiceContainer,
	handlers: {
		onInit:
			() =>
			({ setState }) => {
				setState({
					searchKey: uuid(),
				});
			},
		onContainerUpdate:
			(nextProps, prevProps) =>
			({ dispatch }) => {
				if (!isShallowEqual(nextProps.issueSearchInput, prevProps.issueSearchInput)) {
					dispatch(onSearchInputUpdate());
				}
			},
		onDestroy:
			() =>
			({ getState }) => {
				const { disposables } = getState();
				// Dispose of any manually retained operations when the container is unmounted
				disposables.forEach((disposable) => disposable.dispose());
			},
	},
});
